import React, { useEffect, useState } from "react";
import { Wrapper } from "../components/Wrapper";
import { PageTitle } from "../components/PageTitle";
import { CustomTable } from "../components/CustomTable";
import { useNavigate } from "react-router-dom";
import { Notification } from "../utils/Notification";
import { useMutation, useQuery } from "@apollo/client";
import i18next from "i18next";
import { GET_PLACES } from "../graphql/Queries/PlaceQuery";
import { DELETE_PLACE } from "../graphql/Mutations/PlaceMutation";

export const Places = ({ url }) => {
  const [items, setItems] = useState([]);
  const navigator = useNavigate();

  const { data } = useQuery(GET_PLACES, {
    fetchPolicy: "no-cache",
  });
  const [removePlace] = useMutation(DELETE_PLACE);

  useEffect(() => {
    if (data) {
      setItems(data.places);
    }
  }, [data]);

  const remove = (id) => {
    removePlace({
      variables: {
        id: Number(id),
      },
    })
      .then((response) => {
        setItems(response.data.deletePlace);
      })
      .catch((error) => {
        Notification(error);
      });
  };

  const edit = (id) => {
    navigator(`${url}/form?id=${id}`);
  };

  return (
    <Wrapper>
      <PageTitle title={"Поселки"} />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <CustomTable
                data={items}
                columns={[
                  { key: "id", label: "ID" },
                  { key: "name", label: "Название" },
                  {
                    key: "area",
                    label: "Район",
                    callback: (city) => {
                      const c = city?.name.find((item) => {
                        return item.lang === i18next.language;
                      });
                      return c?.value;
                    },
                  },
                ]}
                search={true}
                sort={true}
                pagination={{
                  limit: 10,
                }}
                actions={[
                  {
                    slug: `${url}/form`,
                    icon: "fe-plus",
                    name: "Создать",
                  },
                ]}
                onClick={(id) => edit(id)}
                onDelete={(id) => remove(id)}
              />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
